import { render } from "./ProveedorPreciosIndex.vue?vue&type=template&id=2f83f4e7"
import script from "./ProveedorPreciosIndex.vue?vue&type=script&lang=js"
export * from "./ProveedorPreciosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/recepciones/ProveedorPreciosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f83f4e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f83f4e7', __exports__)) {
    api.reload('2f83f4e7', __exports__)
  }
  
  module.hot.accept("./ProveedorPreciosIndex.vue?vue&type=template&id=2f83f4e7", () => {
    api.rerender('2f83f4e7', render)
  })

}


export default __exports__